export default "__VITE_ASSET__BGyzbG3S__"